import { useApi } from '@/api';
import { useMemo } from 'react';
import {
  FlexProps,
  useIsMobile,
  Heatmap,
  Flex,
  formatNumber,
  Skeleton
} from '@blockanalitica/ui';
import { HeatmapData } from '@blockanalitica/ui/package/types/src/components/charts/Heatmap/Heatmap';
import { useNavigate } from 'react-router';
import { useTheme } from 'styled-components';

interface ActivityHeatmapProps extends FlexProps {
  url: string;
  linkTo: string;
}

export default function ActivityHeatmap({
  url,
  linkTo,
  ...rest
}: ActivityHeatmapProps) {
  const isMobile = useIsMobile();
  const daysAgo = isMobile ? 120 : 365;
  const [data, error] = useApi<HeatmapData[]>({
    url: url,
    queryParams: {
      days_ago: daysAgo
    }
  });

  const theme = useTheme();
  const navigate = useNavigate();

  function onClickCallback(
    //@ts-ignore
    e: React.MouseEvent<HTMLTableCellElement, MouseEvent>,
    { date }: HeatmapData
  ) {
    navigate(`${linkTo}?date=${date.split('T')[0]}`, { relative: 'path' });
  }

  const total: number = useMemo(() => {
    if (!data) return 0;
    return data.reduce((sum, row) => sum + row.value, 0);
  }, [data]);

  const dateText = useMemo(() => {
    if (daysAgo === 365) {
      return 'year';
    }
    return `${daysAgo / 30} months`;
  }, [daysAgo]);

  if (error) throw error;

  if (!data) {
    return (
      <Flex {...rest}>
        <Skeleton height="10" />
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" gap="3xs" {...rest}>
      <Heatmap
        data={data}
        // {...rest}
        options={{
          daysAgo,
          heatColor: theme.colors.primary,
          onClickCallback: linkTo ? onClickCallback : undefined
          // ...rest.options
        }}
      />

      <Flex color="muted" fontSize="-1" justifyContent="flex-end">
        {formatNumber(total, { notation: 'standard' })} events in the last{' '}
        {dateText}
      </Flex>
    </Flex>
  );
}
